'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 163
// module chunks = 168707334958949